export default "__VITE_ASSET__CvrOl1cr__"